var map = {
	"./Icon=Android.svg": "8717",
	"./Icon=CSS.svg": "e651",
	"./Icon=Dart.svg": "b1c2",
	"./Icon=Figma.svg": "9b59",
	"./Icon=Firebase.svg": "4479",
	"./Icon=Flutter.svg": "12b5",
	"./Icon=Git.svg": "d93f",
	"./Icon=HTML5.svg": "43ae",
	"./Icon=Java.svg": "7e96",
	"./Icon=Javascript.svg": "9d9a",
	"./Icon=Nodejs.svg": "20e5",
	"./Icon=Nuxt.svg": "600a",
	"./Icon=Python.svg": "0af1",
	"./Icon=Tensorflow.svg": "1fac",
	"./Icon=Vue.svg": "a0b0",
	"./Icon=iOS.svg": "40a2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2c48";